export default __webpack_public_path__ + "static/media/os_0.bb3c273b.mp3";